import { render } from "./allPatientsView.vue?vue&type=template&id=7a640a4e&scoped=true"
import script from "./allPatientsView.vue?vue&type=script&lang=js"
export * from "./allPatientsView.vue?vue&type=script&lang=js"

import "./allPatientsView.vue?vue&type=style&index=0&id=7a640a4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a640a4e"]])

export default __exports__